import { Component, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Configuration } from 'src/app/Constants/configuration';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { StorageService } from 'src/app/services/storage.service';
import { CancelacionPolizaComponent } from '../dialogs/cancelacion-poliza/cancelacion-poliza.component';
declare var gtag;

@Component({
    selector: 'opciones-seguros',
    templateUrl: './opciones-seguros.component.html',
    styleUrls: ['./opciones-seguros.component.css']
})
export class OpcionesSeguros {

    public const: Configuration = new Configuration();
    public cia: number;
    public ciaLogo;
    public noSerie: string;

    opciones = [];

    constructor(public dialogRef: MatDialogRef<OpcionesSeguros>,
        private dialog: MatDialog,
        private router: Router,
        private storageService: StorageService) {

    }

    backCotizaciones() {
        console.log("Seleccion principal");
        if (this.const.PLATFORM) {
            window.location.href = this.const.URLPLATFORM + 'cotizacion';
        } else {
            this.router.navigate(['cotizacion']);
        }
        this.dialogRef.close();
    }

    ngOnInit() {
        console.log("Init desde modal: ", this.noSerie);
        //this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
        let cocheSeguro;
        let paquetes: Array<any>;
        let cotizaciones: Array<any>;
        let cia;
        let cotizacionCia;

        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
            cia = cocheSeguro.cia;
        }                

        if (this.storageService.ifExist("cotizaciones")) {
            paquetes = JSON.parse(this.storageService.getItem("cotizaciones"));            
        }

        if(paquetes && paquetes.length > 0) {
            cotizaciones = paquetes[0].cotizaciones;
        }
        
        cotizacionCia = cotizaciones.find(x => x.cia == cia);
        this.ciaLogo = cotizacionCia.logo_aseguradora;

        let contizacionMasComprado = cotizaciones.find(x => x.cia == 49);

        let ordenar = cotizaciones.sort((x, y) => {                   
            return x.prima_total - y.prima_total;
        });
        let cotizacionMenor = ordenar[0];
    
        //Mas barata
        this.opciones.push({
            url: cotizacionMenor.logo_aseguradora,
            ciaId: cotizacionMenor.cia,
            categoria: "./assets/images/paquete/mejorPrecio.png",
            precio: cotizacionMenor.prima_total,
            cotId: cotizacionMenor.cot_id,
            negId: cotizacionMenor.negRecotiza
        });
        //Mas comprada
        if(!(contizacionMasComprado.prima_total == contizacionMasComprado.cot_id)) {
            this.opciones.push({
                url: contizacionMasComprado.logo_aseguradora,
                ciaId: contizacionMasComprado.cia,
                categoria: "./assets/images/paquete/masComprado.png",
                precio: contizacionMasComprado.prima_total,
                cotId: contizacionMasComprado.cot_id,
                negId: contizacionMasComprado.negRecotiza
            });
        }
        

    }
    
    seleccionCompra(tarjeta) {
        console.log("Seleccionaar desde modal");
        let primaTotal = 0;
        let cocheSeguro: CocheSeguro;
        if (this.storageService.ifExist("cocheSeguro")) {
            cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        }
        let data: any = tarjeta.negId;
        sessionStorage.setItem("negId", data);

        cocheSeguro.cot_id = tarjeta.cotId;
        cocheSeguro.cia = tarjeta.ciaId;
        primaTotal = tarjeta.precio;
        this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));

        gtag({
            'event': 'addToCart',
            'seguro': this.getCiaName(tarjeta.ciaId),
            'value': primaTotal
        });

        if (this.const.PLATFORM) {
            window.location.href = this.const.URLPLATFORM + 'datos-emision';
        } else {
            this.router.navigate(['datos-emision']);
        }
        this.dialogRef.close();
    }

    private getCiaName(ciaId) {
        let ciaNames = {
            1 :'ABA',
            14: 'HDI',
            18: 'GNP',
            20: 'AXA',
            22: 'MAPFRE',
            29: 'QUALITAS',
            31: 'AFIRME',
            49: 'PRIMERO'
        }
        
        return ciaNames[ciaId];

    }

    iniciarCancelacion() {
        this.dialogRef.close();
        let dcRef = this.dialog.open(CancelacionPolizaComponent, {
            minHeight: '362px',
            width: '311px',
            maxWidth: '622px',
            disableClose: true
        });
        dcRef.componentInstance.noSerie = this.noSerie;

    }


}

